// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// SCORECARDS MODULE FILTERS
		document.querySelectorAll('.scorecardsModule').forEach(mod => {
			mod.querySelectorAll('.js-scorecardsModule_drop').forEach((field, i) => {
				field.addEventListener('change', e => {
					mod.querySelectorAll('.scorecardsModule_item, .scorecardsModule_top .check').forEach(item => {
						item.classList.remove('enabled');
						if ( item.dataset.tags.indexOf( e.target.value ) > -1 ) {
							item.classList.add('enabled');
						}
					});

					mod.querySelectorAll('.scorecardsModule_item.enabled, .scorecardsModule_top .check.enabled').forEach((item, j) => {
						if ( j === 0 && item.querySelector('.js-scorecardsModule_check') ) {
							const eventChange = document.createEvent('HTMLEvents');
							eventChange.initEvent('change', true, false);
							item.querySelector('.js-scorecardsModule_check').dispatchEvent(eventChange);
							item.querySelector('.js-scorecardsModule_check').checked = true;
						}
					});
				});

				if (i === 0) {
					const eventChange = document.createEvent('HTMLEvents');
					eventChange.initEvent('change', true, false);
					field.dispatchEvent(eventChange);
				}
			});

			mod.querySelectorAll('.js-scorecardsModule_check').forEach(field => {
				field.addEventListener('change', e => {
					mod.querySelectorAll('.scorecardsModule_item').forEach(item => item.classList.remove('active') );
					document.getElementById( e.target.value ).classList.add('active');
				});
			});
		});

		// SCORECARDS TABS
		// document.querySelectorAll('.scorecardsModule_nav-item').forEach((btn, i) => {
		// 	btn.addEventListener('click', _ => {
		// 		document.querySelectorAll('.scorecardsModule_nav-item').forEach(b => b.classList.remove('active'));
		// 		btn.classList.add('active');

		// 		document.querySelectorAll('.scorecardsModule_item').forEach(quad => {
		// 			quad.classList.remove('active');
		// 			if ( btn.dataset.id === quad.id ) {
		// 				quad.classList.add('active');
		// 			}
		// 		});
		// 	});

		// 	if (i === 0) btn.click();
		// });

		// COURSES TABS
		document.querySelectorAll('.quadTabs_nav-item').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				$('.quadTabs_list .sym-slides').slick('unslick');

				document.querySelectorAll('.quadTabs_nav-item').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.quadTabs_list .quad').forEach(quad => {
					quad.classList.remove('active');
					if ( btn.dataset.id === quad.id ) {
						quad.classList.add('active');
					}
				});

				$('.quadTabs_list .sym-slides').slick( slickOptions );
			});

			if (i === 0) btn.click();
		});

		// LIST MODULE FILTERS
		document.querySelectorAll('.listFiltered').forEach(mod => {
			const active_tags = _ => {
				let arr = [];
				mod.querySelectorAll('.js-listFiltered_drop, .js-listFiltered_check:checked').forEach(field => {
					if ( field.value !== '' ) arr.push(field.value);
				});
				return arr;
			};

			const changeHandler = _ => {
				mod.querySelectorAll('.listFiltered_item').forEach(item => {
					item.classList.remove('active');
					if ( active_tags().every( tag => item.dataset.tags.indexOf(tag) > -1 ) ) item.classList.add('active');
				});

				const items_length = mod.querySelectorAll('.listFiltered_item.active').length;
				mod.querySelectorAll('.listFiltered_length span').forEach(num => num.textContent = items_length > 0 ? items_length : 0 );
			};

			mod.querySelectorAll('.js-listFiltered_drop, .js-listFiltered_check').forEach(field => {
				field.addEventListener('change', changeHandler);
			});
		});

		// TOP-CONTENT HEADER SPACE
		document.querySelectorAll('.topContent').forEach(topContent => {
			topContent.style.marginTop = `${document.getElementById('header').offsetHeight}px`;
		});

		// CLOSE HOME LOCATION CARDS
		document.querySelectorAll('.locationModule_item').forEach(item => {
			item.querySelector('.locationModule_item-close').addEventListener('click', _ => {
				item.classList.remove('active');
				document.querySelectorAll('.locationModule_nav a').forEach(b => b.classList.remove('active'));
			});
		});

		// OPEN HOME LOCATION CARDS
		document.querySelectorAll('.locationModule_nav a').forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();
				document.querySelectorAll('.locationModule_nav a, .locationModule_item').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');
				document.querySelector( btn.getAttribute('href') ).classList.add('active');
			});
		});

		// TOGGLE SUBMENU
		document.querySelectorAll('.privary-navigation__item').forEach(item => {
			if ( item.querySelector('.submenu') ) {
				item.querySelector('a').addEventListener('click', e => {
					e.preventDefault();
					item.querySelector('.submenu').classList.toggle('open');
				});
			}
		});

		// TOGGLE LANG
		document.querySelectorAll('.languages_active').forEach(btn => {
			btn.addEventListener('click', _ => {
				document.querySelector('.languages_options').classList.toggle('open');
			});
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
